import Card from '../../components/Card';
import ReferralCreator from './ReferralCreator';
import useUserCreatedReferral from '../../hooks/referral/useUserCreatedReferral';
import ShareReferral from './ShareReferral';
import { useWeb3React } from '@web3-react/core';
import ReferralStats from './ReferralStats';
import { Tab, TabBody, TabHeader, Tabs } from '../../components/Tabs';
import PayoutActivity from './PayoutActivity';
import ReferralList from './ReferralList';
import useUserReferralStats from '../../hooks/referral/useUserReferralStats';
import Spinner from '../../components/Spinner';
import Button from '../../components/Button';

const ROW_MARGIN = 16;
const DATA_PER_ROW = 5;

const Referrals = () => {
    const { account } = useWeb3React();

    const { userCreatedReferral, isLoading } = useUserCreatedReferral(account);

    const { isLoading: referrralStatsLoading, userReferralStats } =
        useUserReferralStats();

    return (
        <section id='referrals'>
            <div className='container'>
                <div className='content'>
                    <h2>
                        Spread The Word <br />& Earn Rewards
                    </h2>
                    <p>
                        Generate your referral link, invite your friends to trade on
                        Unlimited Leverage, and earn a{' '}
                        <strong>LIFETIME 10% fixed fee</strong> (up to 25%) from all their
                        trades.{' '}
                        <Button
                            variant='secondary'
                            externalLink='https://docs.unlimited.trade/protocol/or-referrals'
                        >
                            View referral rules
                        </Button>
                    </p>
                    <ReferralStats />
                    <Card className='referral-input-card'>
                        {account ? (
                            !isLoading && userCreatedReferral ? (
                                <ShareReferral />
                            ) : (
                                <ReferralCreator />
                            )
                        ) : (
                            <span className='not-connected'>
                                Connect your wallet to continue
                            </span>
                        )}
                        <svg id='referral-input-line' width='100%' height='1'>
                            <line
                                x1='0'
                                y1='1'
                                x2='100%'
                                y2='1'
                                stroke='rgba(255,255,255,0.5)'
                                strokeDasharray='6'
                            />
                        </svg>
                    </Card>
                    {account && (
                        <Card className='referrals-history'>
                            {referrralStatsLoading ? (
                                <div className='loading-container'>
                                    <Spinner />
                                    <span>Loading your earnings...</span>
                                </div>
                            ) : userReferralStats?.referredCount ? (
                                <Tabs>
                                    <TabHeader>
                                        <Tab>Payout Activity</Tab>
                                        <Tab>My Referrals</Tab>
                                    </TabHeader>
                                    <TabBody>
                                        <PayoutActivity
                                            dataPerRow={DATA_PER_ROW}
                                            rowMargin={ROW_MARGIN}
                                        />
                                        <ReferralList
                                            dataPerRow={DATA_PER_ROW}
                                            rowMargin={ROW_MARGIN}
                                        />
                                    </TabBody>
                                </Tabs>
                            ) : (
                                <span className='no-referrals'>
                                    Invite your friends & start earning!
                                </span>
                            )}
                        </Card>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Referrals;
